export const translations = {
  it: {
    brand: "ReValue",
    nav: {
      valuate: "Valuta",
      guide: "Guide",
      history: "Cronologia",
      login: "Accedi",
      signup: "Registrati",
      logout: "Esci",
    },
    landing: {
      kicker: "Prezzo · Strategia · Profitto",
      h1_part1: "Valuta il tuo usato",
      h1_part2: "in tempo reale.",
      sub: "Genera l'annuncio perfetto e vendi al miglior prezzo su Subito, Vinted ed eBay. Inserisci categoria, condizioni e prezzo di acquisto: il nostro algoritmo confronta deprezzamento, domanda e stagionalità e ti restituisce subito la stima di mercato con tre strategie di vendita pronte all'uso.",
      cta_primary: "Calcola il prezzo",
      cta_secondary: "Come funziona",
      stat1_n: "3", stat1_l: "strategie di prezzo",
      stat2_n: "26", stat2_l: "categorie supportate",
      stat3_n: "4", stat3_l: "marketplace coperti",
      how_title: "Tre strategie. Una sola decisione.",
      how_sub: "Inserisci i dettagli del tuo prodotto. Il nostro motore + AI Claude calcola tre prezzi ottimali, ognuno con tempistica e canali consigliati.",
      strat_fast: "Vendita Rapida",
      strat_fast_desc: "Per chi vuole chiudere in pochi giorni.",
      strat_balanced: "Equilibrato",
      strat_balanced_desc: "Il giusto compromesso tra tempo e margine.",
      strat_max: "Massimo Profitto",
      strat_max_desc: "Per chi può aspettare l'acquirente giusto.",
      steps_title: "Come funziona ReValue: l'Intelligenza Artificiale per l'usato",
      step1_t: "Inserisci i dettagli del tuo oggetto",
      step1_d: "Scegli la categoria tra le 26 disponibili — dall'elettronica all'abbigliamento, dai veicoli ai libri — poi indica marca, modello, condizioni reali e prezzo di acquisto. Puoi aggiungere anche foto, scatola originale, accessori e garanzia: più dettagli fornisci, più la stima sarà precisa e vicina al reale valore di mercato.",
      step2_t: "Il nostro algoritmo analizza il mercato",
      step2_d: "Il motore di valutazione incrocia il deprezzamento tipico della categoria con lo stato d'uso, la rarità, la stagionalità e la dotazione del tuo oggetto. L'analisi AI di descrizione e fotografie affina il risultato, restituendo una stima onesta di quanto vale oggi il tuo usato sul mercato secondario.",
      step3_t: "Ottieni valutazione e annuncio pronti",
      step3_d: "Ricevi la stima esatta con tre strategie di prezzo — vendita rapida, equilibrata o massimo profitto — ognuna con tempistiche e canali consigliati. Scegli il prezzo che preferisci e genera in un clic l'annuncio già scritto, pronto da incollare su Vinted, eBay, Subito o Facebook Marketplace.",
      cta_bottom: "Pronto a vendere?",
      cta_bottom_btn: "Inizia ora",
      footer_tag: "Stima · Strategia · Vendita",
      search_overline: "RICERCA RAPIDA",
      search_placeholder: "iPhone 13, Golf, Pandora...",
      search_hint: "Inizia a digitare il modello — l'AI fa il resto",
      search_empty: "Nessun risultato. Prova un altro termine o continua manualmente.",
      search_enter: "INVIO per valutare",
      search_skip: "INSERIMENTO MANUALE →",
      trending_title: "Più cercati questa settimana",
    },
    auth: {
      login_title: "Accedi",
      signup_title: "Crea account",
      name: "Nome",
      email: "Email",
      password: "Password",
      submit_login: "Accedi",
      submit_signup: "Crea account",
      no_account: "Non hai un account?",
      have_account: "Hai già un account?",
      go_signup: "Registrati",
      go_login: "Accedi",
      error_login: "Email o password non validi",
      error_signup: "Errore durante la registrazione",
    },
    valuator: {
      title: "Valuta un prodotto",
      sub: "Compila i campi. Più informazioni dai, più precisa sarà la stima.",
      section_basics: "Informazioni base",
      section_details: "Dettagli prodotto",
      section_extras: "Descrizione e foto",
      category: "Categoria",
      brand: "Marca",
      model: "Modello",
      purchase_price: "Prezzo di acquisto (€)",
      original_retail: "Prezzo di listino (€)",
      purchase_price_ph: "es. 250",
      retail_price_ph: "es. 300",
      age_too_high: "L'età del prodotto sembra troppo alta. Inserisci i mesi o gli anni di età, non l'anno di acquisto.",
      price_tooltip_purchase: "Quanto l'hai pagato tu, nuovo o usato. Basta uno dei due prezzi per ottenere la stima.",
      price_tooltip_retail: "Il prezzo dell'oggetto quando è uscito nuovo sul mercato. Aiuta l'algoritmo a essere molto più preciso.",
      price_or_hint: "Inserisci almeno uno dei due prezzi per continuare",
      purchase_type_q: "Come hai acquistato questo oggetto?",
      purchase_type_new: "Nuovo",
      purchase_type_used: "Usato / Ricondizionato",
      owned_time_new: "Da quanto tempo lo possiedi?",
      owned_time_used: "Da quanto tempo lo possiedi tu?",
      age_at_purchase_q: "Quanti anni o mesi aveva quando l'hai comprato?",
      age_at_purchase_help: "Se non lo sai con precisione, stimalo dall'anno di uscita o produzione dell'oggetto.",
      unit_months: "Mesi",
      unit_years: "Anni",
      condition: "Condizioni",
      condition_help_title: "Come scegliere le condizioni:",
      age: "Età del prodotto (mesi)",
      usage_hours: "Tempo effettivo di utilizzo (ore) — opzionale",
      usage_hours_help: "Es: un laptop usato 8h/giorno per 1 anno = ~2920h. Se sai quanto l'hai usato davvero, indicalo.",
      kilometers: "Chilometri percorsi",
      kilometers_help: "Riferimento medio: ~15.000 km/anno. Sotto la media aumenta il valore.",
      material: "Materiale principale",
      material_help: "Es: oro 18kt, argento 925, acciaio, pelle, legno massello...",
      has_box: "Scatola originale",
      has_accessories: "Accessori originali",
      has_warranty: "Garanzia attiva",
      description: "Descrizione (opzionale) — più dettagli = stima migliore",
      photos: "Foto del prodotto (opzionali, max 3) — l'AI le analizzerà",
      photos_drop: "Trascina qui o clicca per caricare",
      photos_format: "JPG, PNG, WEBP · max 8MB ciascuna",
      photos_uploading: "Caricamento in corso...",
      photo_remove: "Rimuovi",
      photo_too_large: "La foto supera i 5MB anche dopo la compressione e non può essere caricata.",
      photo_upload_failed: "Caricamento della foto non riuscito. Riprova.",
      submit: "Calcola prezzo",
      calculating: "Calcolo in corso...",
      conditions: {
        new: "Nuovo",
        like_new: "Come nuovo",
        very_good: "Ottime",
        good: "Buone",
        fair: "Discrete",
        poor: "Usurato",
        damaged: "Danneggiato",
        for_parts: "Inutilizzabile",
      },
      condition_desc: {
        new: "Mai usato, ancora sigillato nella confezione originale.",
        like_new: "Aperto ma usato pochissimo. Nessun segno visibile.",
        very_good: "Usato regolarmente ma con grande cura. Lievi segni d'uso.",
        good: "Segni d'uso visibili (graffi, ammaccature minori). Tutto funziona perfettamente.",
        fair: "Usura evidente, segni multipli o piccoli difetti estetici. Funziona correttamente.",
        poor: "Molto usato, difetti estetici importanti. Può richiedere piccole riparazioni.",
        damaged: "Oggetto da riparare. Funziona parzialmente o non funziona, ma è recuperabile con interventi.",
        for_parts: "Inutilizzabile: utile solo come fonte di pezzi di ricambio.",
      },
      brand_placeholder: "Seleziona prima la categoria",
      brand_select: "Seleziona la marca",
      model_select: "Seleziona il modello",
      other_option: "Altro / non in lista",
      custom_brand_placeholder: "Specifica la marca",
      custom_model_placeholder: "Specifica il modello",
      optional_select: "— non specificato —",
      step_next: "Continua",
      step_back: "Indietro",
      urgency: "Quanto hai fretta di vendere?",
      urgencies: {
        fast: "Voglio vendere in fretta",
        balanced: "Nessuna fretta particolare",
        max_profit: "Voglio il massimo guadagno",
      },
      quick_range_btn: "Mostra range di prezzo",
      quick_range_loading: "Calcolo range...",
      quick_range_title: "Range di prezzo stimato",
      quick_range_note: "Stima indicativa basata sui dati essenziali. Aggiungi i dettagli per un prezzo preciso e i consigli AI personalizzati.",
      more_precise: "Vuoi un prezzo più preciso?",
      repair_status: "Interventi subiti / riparazioni",
      repair_statuses: {
        never: "Mai riparato",
        repaired_original: "Riparato con ricambi originali",
        repaired_compatible: "Riparato con ricambi compatibili",
      },
      repair_details: "Dettaglio interventi",
      repair_details_ph: "es. schermo sostituito, batteria nuova, motore rifatto...",
      seasonality: "Stagionalità del prodotto",
      seasonalities: {
        none: "Non stagionale",
        summer: "Prodotto estivo (SUP, condizionatori, bici...)",
        winter: "Prodotto invernale (sci, stufe, piumini...)",
      },
      take_photo: "Scatta foto",
      model_autofill: "Auto-compilato dal catalogo",
      release_year: "uscita",
      list_price: "listino",
      storage: "Memoria / capacità",
      item_size: "Taglia",
      item_size_ph: "es. M, 42, 44 EU...",
      has_certificate: "Certificato di autenticità (se applicabile)",
      has_verifiable_serial: "Seriale / Fattura verificabile",
      rarity: "Rarità e reperibilità",
      rarities: {
        common: "Comune / facilmente reperibile",
        out_of_production: "Fuori produzione",
        limited_edition: "Edizione limitata / tiratura numerata",
        rare_variant: "Variante rara (colore o specifiche particolari)",
      },
      energy_class: "Classe di efficienza energetica",
      vehicle_adv: "Dettagli avanzati veicolo",
      vehicle_adv_hint: "Tagliandi, carrozzeria, classe Euro, alimentazione, proprietari — più dati = stima più precisa",
      service_history: "Cronologia tagliandi (libretto service)",
      service_histories: {
        full: "Completa e documentata (officine autorizzate)",
        partial: "Parziale / non sempre documentata",
        none: "Assente / fai da te",
      },
      recent_maintenance: "Interventi straordinari recenti",
      recent_maintenance_ph: "es. cinghia distribuzione, frizione, gomme nuove, freni...",
      body_condition: "Stato carrozzeria",
      interior_condition: "Stato interni / abitacolo",
      vehicle_conditions: { excellent: "Eccellente", good: "Buono", fair: "Discreto", poor: "Scarso" },
      electronics_ok: "Elettronica di bordo (clima, infotainment, sensori, ADAS)",
      electronics_options: { yes: "Tutto funzionante", no: "Presenta problemi" },
      euro_class: "Classe di omologazione Euro",
      fuel_type: "Alimentazione",
      fuel_types: {
        petrol: "Benzina",
        diesel: "Diesel",
        lpg: "GPL",
        methane: "Metano",
        hybrid: "Full Hybrid",
        plugin_hybrid: "Plug-in Hybrid",
        electric: "100% Elettrica",
      },
      battery_soh: "Stato di salute batteria (SoH %)",
      engine_cc: "Cilindrata (cc)",
      power_kw: "Potenza (kW)",
      power_kw_help: "Trovi il dato alla voce P.2 del libretto di circolazione.",
      owners_count: "Proprietari precedenti",
      recent_inspection: "Revisione recente / garanzia residua attiva",
      book_details: "Dettagli libro",
      book_edition: "Tipo di edizione",
      book_editions: {
        mass_paperback: "Tascabile / edizione di massa",
        standard: "Edizione standard",
        first_edition: "Prima edizione / prima tiratura",
        limited_numbered: "Edizione limitata / numerata",
        antique: "Libro antico (antiquariato)",
      },
      is_signed: "Autografo / dedica dell'autore",
      out_of_print: "Fuori catalogo (non più stampato)",
      has_dust_jacket: "Sovraccoperta originale presente",
      has_annotations: "Sottolineature o note (penna/evidenziatore)",
      pc_specs_section: "Specifiche tecniche (PC & Hardware)",
      pc_specs_hint: "Opzionali ma consigliate: rendono la stima e l'annuncio più precisi e credibili.",
      pc_component_type: "Tipo di prodotto / componente",
      pc_types: {
        desktop: "PC Desktop (fisso completo)",
        laptop: "PC Portatile / Notebook",
        gpu: "Scheda video (GPU)",
        cpu: "Processore (CPU)",
        ram: "Memoria RAM",
        storage: "Archiviazione (SSD/HDD)",
        motherboard: "Scheda madre",
        psu: "Alimentatore (PSU)",
      },
      vram: "Memoria VRAM",
      vram_ph: "8GB, 12GB, 24GB...",
      cpu_socket: "Socket / Generazione",
      cpu_socket_ph: "AM4, AM5, LGA1700...",
      ram_storage_spec: "Capacità e velocità",
      ram_storage_ph: "16GB 3200MHz, 1TB NVMe...",
      gpu_usage: "Utilizzo scheda video",
      gpu_usages: { gaming: "Solo gaming", mining: "Usata anche per mining", mixed: "Uso misto / produttività" },
      pc_build_specs: "Specifiche principali (CPU, GPU, RAM, Storage)",
      pc_build_specs_ph: "i5-12400F, RTX 3060, 16GB DDR4, 512GB NVMe...",
    },
    results: {
      title: "Stima completata",
      market_value: "Valore di mercato stimato",
      reasoning: "Analisi",
      confidence: "Affidabilità",
      conf: { low: "Bassa", medium: "Media", high: "Alta" },
      data_reliability: "Affidabilità dei dati",
      data_reliability_hint: "Più dettagli inserisci, più la stima diventa precisa.",
      reliability: { low: "Bassa", medium: "Media", high: "Alta" },
      strategy: "Strategia",
      price: "Prezzo",
      timeline: "Tempistica",
      channels: "Canali consigliati",
      bundle_title: "Analisi smontaggio",
      bundle_hint: "Confronto tra vendere il PC completo o separare i componenti principali.",
      bundle_whole: "Valore PC intero",
      bundle_parts: "Valore venduto a pezzi",
      bundle_parts_note: "GPU, CPU, RAM separati",
      bundle_tip: "Suggerimento: smontando il PC potresti guadagnare circa il 20% in più, ma dovrai gestire più spedizioni e più acquirenti.",
      tips: "Consigli",
      save: "Salva nella cronologia",
      saved: "Salvato nella cronologia",
      new_valuation: "Nuova valutazione",
      login_to_save: "Accedi per salvare",
      photos_label: "Foto",
      recommended: "Consigliata per te",
      share: "Condividi link pubblico",
      share_copied: "Link copiato! Invialo ai potenziali acquirenti come prova del prezzo",
      share_ready: "Link generato — copialo qui sotto",
      share_label: "Link pubblico",
      listing_title: "Generatore annuncio",
      listing_sub: "Testo pronto da incollare, scritto dall'AI con i dati del tuo prodotto e adattato al marketplace.",
      listing_copy: "Copia testo",
      listing_copied: "Testo copiato negli appunti!",
      listing_copy_failed: "Copia non riuscita — seleziona e copia manualmente il testo",
      listing_open: "Apri su",
      listing_open_hint: "Testo copiato! Incollalo nel modulo di",
      select_prompt: "Tocca una delle 3 strategie per scegliere il tuo prezzo di vendita",
      price_selected: "Prezzo scelto",
      tap_to_select: "Tocca per scegliere questo prezzo",
      listing_locked: "Scegli prima uno dei 3 prezzi qui sopra: l'annuncio verrà scritto su misura per la strategia selezionata.",
      listing_pick_hint: "Seleziona un marketplace per generare il testo ottimizzato",
      email_title: "Ricevi la stima via email",
      email_hint: "Ti inviamo il riepilogo della stima e l'annuncio pronto da pubblicare.",
      email_placeholder: "La tua email",
      email_send: "Invia stima alla mia email",
      email_sending: "Invio in corso...",
      email_sent: "Email inviata con successo!",
      email_invalid: "Inserisci un indirizzo email valido",
      listing_for: "Annuncio su misura per",
    },
    dashboard: {
      title: "Cronologia valutazioni",
      empty: "Nessuna valutazione salvata. Inizia ora!",
      alerts_title: "Avvisi prezzo",
      alerts_up: "in rialzo",
      alerts_none: "Nessun rialzo di valore al momento: ricontrolliamo automaticamente le tue valutazioni a ogni visita.",
      alerts_sell: "Buon momento per vendere",
      alerts_then: "Valutato",
      alerts_now: "Oggi",
      delete: "Elimina",
      deleted: "Valutazione eliminata",
      trend_title: "TREND PREZZI PER CATEGORIA",
      trend_empty: "Salva almeno 2 valutazioni in questa categoria per vedere il trend.",
      compare: "Confronta",
      compare_title: "CONFRONTO VALUTAZIONI",
      compare_hint: "Seleziona un'altra valutazione (icona bilancia) per confrontarle fianco a fianco",
      best_margin: "Miglior margine",
      margin: "Margine (prezzo equilibrato − acquisto)",
      purchase: "Prezzo d'acquisto",
      share: "Condividi",
      share_copied: "Link pubblico copiato negli appunti!",
    },
    shared: {
      badge: "Valutazione verificata ReValue",
      by: "Generata con ReValue — Resale Value Engine",
      cta: "Fai la tua valutazione gratuita",
      invalid: "Link non valido o rimosso",
      date: "Data valutazione",
    },
    common: {
      yes: "Sì", no: "No",
      back: "Indietro",
      ad_placeholder: "Spazio pubblicitario",
    },
    cookies: {
      title: "Questo sito usa i cookie",
      text: "Usiamo cookie tecnici e, previo consenso, cookie pubblicitari di terze parti (Google AdSense) per mostrarti annunci. Puoi rifiutare: il sito funziona comunque.",
      accept: "Accetta",
      reject: "Rifiuta",
      more: "Privacy & Cookie Policy",
    },
  },
  en: {
    brand: "ReValue",
    nav: {
      valuate: "Valuate",
      guide: "Guides",
      history: "History",
      login: "Log in",
      signup: "Sign up",
      logout: "Log out",
    },
    landing: {
      kicker: "Price · Strategy · Profit",
      h1_part1: "Value your used items",
      h1_part2: "in real time.",
      sub: "Generate the perfect listing and sell at the best price on Subito, Vinted and eBay. Enter category, condition and purchase price: our algorithm weighs depreciation, demand and seasonality and instantly returns the market estimate with three ready-to-use selling strategies.",
      cta_primary: "Get a price",
      cta_secondary: "How it works",
      stat1_n: "3", stat1_l: "pricing strategies",
      stat2_n: "26", stat2_l: "supported categories",
      stat3_n: "4", stat3_l: "covered marketplaces",
      how_title: "Three strategies. One decision.",
      how_sub: "Enter the details of your product. Our engine + Claude AI compute three optimal prices, each with timeline and recommended channels.",
      strat_fast: "Fast Sale",
      strat_fast_desc: "For when you want to close in days.",
      strat_balanced: "Balanced",
      strat_balanced_desc: "The right balance of speed and margin.",
      strat_max: "Max Profit",
      strat_max_desc: "For when you can wait for the right buyer.",
      steps_title: "How ReValue works: AI for second-hand goods",
      step1_t: "Enter your item's details",
      step1_d: "Pick one of 26 categories — from electronics to clothing, vehicles to books — then set brand, model, real condition and purchase price. Add photos, original box, accessories and warranty too: the more details you provide, the more accurate and market-realistic the estimate will be.",
      step2_t: "Our algorithm analyses the market",
      step2_d: "The valuation engine crosses category-specific depreciation with wear, rarity, seasonality and what's included with your item. AI analysis of your description and photos refines the result, returning an honest estimate of what your item is worth on today's second-hand market.",
      step3_t: "Get your valuation and ready listing",
      step3_d: "Receive the exact estimate with three pricing strategies — fast sale, balanced or max profit — each with timelines and recommended channels. Pick your favourite price and generate a fully written listing in one click, ready to paste on Vinted, eBay, Subito or Facebook Marketplace.",
      cta_bottom: "Ready to sell?",
      cta_bottom_btn: "Start now",
      footer_tag: "Estimate · Strategy · Sale",
      search_overline: "QUICK SEARCH",
      search_placeholder: "iPhone 13, Golf, Pandora...",
      search_hint: "Start typing the model — the AI does the rest",
      search_empty: "No matches. Try another term or continue manually.",
      search_enter: "ENTER to valuate",
      search_skip: "MANUAL ENTRY →",
      trending_title: "Most searched this week",
    },
    auth: {
      login_title: "Log in",
      signup_title: "Create account",
      name: "Name",
      email: "Email",
      password: "Password",
      submit_login: "Log in",
      submit_signup: "Create account",
      no_account: "No account yet?",
      have_account: "Already have an account?",
      go_signup: "Sign up",
      go_login: "Log in",
      error_login: "Invalid email or password",
      error_signup: "Sign up failed",
    },
    valuator: {
      title: "Valuate a product",
      sub: "Fill in the fields. The more data you provide, the more accurate the estimate.",
      section_basics: "Basics",
      section_details: "Product details",
      section_extras: "Description & photos",
      category: "Category",
      brand: "Brand",
      model: "Model",
      purchase_price: "Purchase price (€)",
      original_retail: "Original retail price (€)",
      purchase_price_ph: "e.g. 250",
      retail_price_ph: "e.g. 300",
      age_too_high: "The product age looks too high. Enter the age in months or years, not the year of purchase.",
      price_tooltip_purchase: "What you paid for it, new or used. One of the two prices is enough to get the estimate.",
      price_tooltip_retail: "The item's price when it launched new on the market. It helps the algorithm be much more accurate.",
      price_or_hint: "Enter at least one of the two prices to continue",
      purchase_type_q: "How did you buy this item?",
      purchase_type_new: "New",
      purchase_type_used: "Used / Refurbished",
      owned_time_new: "How long have you owned it?",
      owned_time_used: "How long have YOU owned it?",
      age_at_purchase_q: "How old was the item when you bought it?",
      age_at_purchase_help: "If unsure, estimate it from the item's release or production year.",
      unit_months: "Months",
      unit_years: "Years",
      condition: "Condition",
      condition_help_title: "How to pick the right condition:",
      age: "Product age (months)",
      usage_hours: "Effective usage time (hours) — optional",
      usage_hours_help: "E.g.: a laptop used 8h/day for 1 year ≈ 2920h. If you know the real usage, add it.",
      kilometers: "Kilometers driven",
      kilometers_help: "Average reference: ~15,000 km/year. Below average increases the value.",
      material: "Main material",
      material_help: "E.g.: 18kt gold, sterling silver, steel, leather, solid wood...",
      has_box: "Original box",
      has_accessories: "Original accessories",
      has_warranty: "Active warranty",
      description: "Description (optional) — more details = better estimate",
      photos: "Product photos (optional, max 3) — the AI will analyse them",
      photos_drop: "Drop here or click to upload",
      photos_format: "JPG, PNG, WEBP · max 8MB each",
      photos_uploading: "Uploading...",
      photo_remove: "Remove",
      photo_too_large: "The photo still exceeds 5MB after compression and can't be uploaded.",
      photo_upload_failed: "Photo upload failed. Please try again.",
      submit: "Calculate price",
      calculating: "Calculating...",
      conditions: {
        new: "New",
        like_new: "Like new",
        very_good: "Very good",
        good: "Good",
        fair: "Fair",
        poor: "Worn",
        damaged: "Damaged",
        for_parts: "For parts",
      },
      condition_desc: {
        new: "Never used, still sealed in the original packaging.",
        like_new: "Opened but barely used. No visible marks.",
        very_good: "Regularly used but kept carefully. Light signs of use.",
        good: "Visible signs of use (scratches, minor dings). Fully functional.",
        fair: "Clear wear, multiple marks or small cosmetic defects. Works correctly.",
        poor: "Heavily used, major cosmetic defects. May need small repairs.",
        damaged: "Object to be repaired. Works partially or not at all, but can be fixed.",
        for_parts: "Unusable: only useful as a source of spare parts.",
      },
      brand_placeholder: "Pick a category first",
      brand_select: "Select brand",
      model_select: "Select model",
      other_option: "Other / not listed",
      custom_brand_placeholder: "Type the brand",
      custom_model_placeholder: "Type the model",
      optional_select: "— not specified —",
      step_next: "Continue",
      step_back: "Back",
      urgency: "How urgently do you need to sell?",
      urgencies: {
        fast: "I want to sell fast",
        balanced: "No particular rush",
        max_profit: "I want maximum profit",
      },
      quick_range_btn: "Show price range",
      quick_range_loading: "Computing range...",
      quick_range_title: "Estimated price range",
      quick_range_note: "Indicative estimate based on the essentials. Add details for a precise price and tailored AI advice.",
      more_precise: "Want a more precise price?",
      repair_status: "Repair history",
      repair_statuses: {
        never: "Never repaired",
        repaired_original: "Repaired with original parts",
        repaired_compatible: "Repaired with compatible parts",
      },
      repair_details: "Repair details",
      repair_details_ph: "e.g. screen replaced, new battery, rebuilt engine...",
      seasonality: "Product seasonality",
      seasonalities: {
        none: "Not seasonal",
        summer: "Summer product (SUP, AC units, bikes...)",
        winter: "Winter product (skis, heaters, down jackets...)",
      },
      take_photo: "Take a photo",
      model_autofill: "Auto-filled from catalog",
      release_year: "released",
      list_price: "list price",
      storage: "Storage capacity",
      item_size: "Size",
      item_size_ph: "e.g. M, 42, 44 EU...",
      has_certificate: "Certificate of authenticity (if applicable)",
      has_verifiable_serial: "Verifiable serial / invoice",
      rarity: "Rarity & availability",
      rarities: {
        common: "Common / easy to find",
        out_of_production: "Out of production",
        limited_edition: "Limited / numbered edition",
        rare_variant: "Rare variant (special color or specs)",
      },
      energy_class: "Energy efficiency class",
      vehicle_adv: "Advanced vehicle details",
      vehicle_adv_hint: "Service history, bodywork, Euro class, fuel, owners — more data = better estimate",
      service_history: "Service history (service book)",
      service_histories: {
        full: "Complete and documented (authorized workshops)",
        partial: "Partial / not always documented",
        none: "None / DIY maintenance",
      },
      recent_maintenance: "Recent major maintenance",
      recent_maintenance_ph: "e.g. timing belt, clutch, new tires, brakes...",
      body_condition: "Bodywork condition",
      interior_condition: "Interior condition",
      vehicle_conditions: { excellent: "Excellent", good: "Good", fair: "Fair", poor: "Poor" },
      electronics_ok: "Onboard electronics (AC, infotainment, sensors, ADAS)",
      electronics_options: { yes: "All working", no: "Has issues" },
      euro_class: "Euro emission class",
      fuel_type: "Fuel type",
      fuel_types: {
        petrol: "Petrol",
        diesel: "Diesel",
        lpg: "LPG",
        methane: "CNG",
        hybrid: "Full Hybrid",
        plugin_hybrid: "Plug-in Hybrid",
        electric: "100% Electric",
      },
      battery_soh: "Battery State of Health (SoH %)",
      engine_cc: "Engine size (cc)",
      power_kw: "Power (kW)",
      power_kw_help: "Find this value at field P.2 of the vehicle registration document.",
      owners_count: "Previous owners",
      recent_inspection: "Recent inspection / active residual warranty",
      book_details: "Book details",
      book_edition: "Edition type",
      book_editions: {
        mass_paperback: "Paperback / mass edition",
        standard: "Standard edition",
        first_edition: "First edition / first printing",
        limited_numbered: "Limited / numbered edition",
        antique: "Antique book (antiquarian)",
      },
      is_signed: "Author's autograph / dedication",
      out_of_print: "Out of print",
      has_dust_jacket: "Original dust jacket present",
      has_annotations: "Underlining or notes (pen/highlighter)",
      pc_specs_section: "Technical specs (PC & Hardware)",
      pc_specs_hint: "Optional but recommended: they make the estimate and listing more precise and credible.",
      pc_component_type: "Product / component type",
      pc_types: {
        desktop: "Desktop PC (full tower)",
        laptop: "Laptop / Notebook",
        gpu: "Graphics card (GPU)",
        cpu: "Processor (CPU)",
        ram: "RAM memory",
        storage: "Storage (SSD/HDD)",
        motherboard: "Motherboard",
        psu: "Power supply (PSU)",
      },
      vram: "VRAM memory",
      vram_ph: "8GB, 12GB, 24GB...",
      cpu_socket: "Socket / Generation",
      cpu_socket_ph: "AM4, AM5, LGA1700...",
      ram_storage_spec: "Capacity & speed",
      ram_storage_ph: "16GB 3200MHz, 1TB NVMe...",
      gpu_usage: "GPU usage",
      gpu_usages: { gaming: "Gaming only", mining: "Also used for mining", mixed: "Mixed / productivity" },
      pc_build_specs: "Main specs (CPU, GPU, RAM, Storage)",
      pc_build_specs_ph: "i5-12400F, RTX 3060, 16GB DDR4, 512GB NVMe...",
    },
    results: {
      title: "Estimate complete",
      market_value: "Estimated market value",
      reasoning: "Analysis",
      confidence: "Confidence",
      conf: { low: "Low", medium: "Medium", high: "High" },
      data_reliability: "Data reliability",
      data_reliability_hint: "The more details you add, the more precise the estimate.",
      reliability: { low: "Low", medium: "Medium", high: "High" },
      strategy: "Strategy",
      price: "Price",
      timeline: "Timeline",
      channels: "Recommended channels",
      bundle_title: "Teardown analysis",
      bundle_hint: "Comparison between selling the whole PC or parting out the main components.",
      bundle_whole: "Whole PC value",
      bundle_parts: "Sold as separate parts",
      bundle_parts_note: "GPU, CPU, RAM separately",
      bundle_tip: "Tip: parting out the PC could earn you ~20% more, but you'll juggle more shipments and buyers.",
      tips: "Tips",
      save: "Save to history",
      saved: "Saved to history",
      new_valuation: "New valuation",
      login_to_save: "Log in to save",
      photos_label: "Photos",
      recommended: "Recommended for you",
      share: "Share public link",
      share_copied: "Link copied! Send it to potential buyers as price proof",
      share_ready: "Link generated — copy it below",
      share_label: "Public link",
      listing_title: "Listing generator",
      listing_sub: "Ready-to-paste text, AI-written from your product data and adapted to the marketplace.",
      listing_copy: "Copy text",
      listing_copied: "Text copied to clipboard!",
      listing_copy_failed: "Copy failed — select and copy the text manually",
      listing_open: "Open on",
      listing_open_hint: "Text copied! Paste it into the form on",
      select_prompt: "Tap one of the 3 strategies to pick your selling price",
      price_selected: "Selected price",
      tap_to_select: "Tap to pick this price",
      listing_locked: "First pick one of the 3 prices above: the listing will be tailored to the selected strategy.",
      listing_pick_hint: "Select a marketplace to generate the optimised text",
      email_title: "Get the estimate by email",
      email_hint: "We'll send you the estimate summary and the ready-to-post listing.",
      email_placeholder: "Your email",
      email_send: "Send estimate to my email",
      email_sending: "Sending...",
      email_sent: "Email sent successfully!",
      email_invalid: "Enter a valid email address",
      listing_for: "Listing tailored for",
    },
    dashboard: {
      title: "Valuation history",
      empty: "No saved valuations yet. Get started!",
      alerts_title: "Price alerts",
      alerts_up: "rising",
      alerts_none: "No value increases right now: we automatically re-check your valuations on every visit.",
      alerts_sell: "Good time to sell",
      alerts_then: "Valued",
      alerts_now: "Today",
      delete: "Delete",
      deleted: "Valuation deleted",
      trend_title: "PRICE TREND BY CATEGORY",
      trend_empty: "Save at least 2 valuations in this category to see the trend.",
      compare: "Compare",
      compare_title: "VALUATION COMPARISON",
      compare_hint: "Select another valuation (scale icon) to compare them side by side",
      best_margin: "Best margin",
      margin: "Margin (balanced price − purchase)",
      purchase: "Purchase price",
      share: "Share",
      share_copied: "Public link copied to clipboard!",
    },
    shared: {
      badge: "ReValue verified valuation",
      by: "Generated with ReValue — Resale Value Engine",
      cta: "Get your free valuation",
      invalid: "Invalid or removed link",
      date: "Valuation date",
    },
    common: {
      yes: "Yes", no: "No",
      back: "Back",
      ad_placeholder: "Advertising space",
    },
    cookies: {
      title: "This site uses cookies",
      text: "We use technical cookies and, with your consent, third-party advertising cookies (Google AdSense) to show you ads. You can reject: the site still works.",
      accept: "Accept",
      reject: "Reject",
      more: "Privacy & Cookie Policy",
    },
  },
};
